import { render, staticRenderFns } from "./ConsultantSeller.vue?vue&type=template&id=1871e011"
import script from "./ConsultantSeller.vue?vue&type=script&lang=js"
export * from "./ConsultantSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports